export function GetJobData(jobKey, paths, firebaseReference) {
  let firebase = firebaseReference || FirebaseWorker;
  // this check is to prevent a pass by reference issue where GetJobData is called more than once with the same array
  if (Array.isArray(paths)) {
    paths = paths.slice();
  }
  return new Promise((resolve, reject) => {
    let temp = {};
    let count = 0;
    if (paths) {
      if (paths == null) paths = [];
      else if (paths.constructor !== Array) paths = [paths];
      if (paths.length == 0) resolve(temp);
      else
        for (const path of paths) {
          // Create any listeners that we should have
          manageListeners(jobKey, path);
          // Fetch the data
          firebase
            .database()
            .ref(`/photoheight/jobs/${jobKey}`)
            .child(path)
            .once('value', (s) => {
              temp[path] = s.val();
              if (++count == paths.length) resolve(temp);
            });
        }
    } else {
      resolve(null);
    }
  });
}

// A list of active on-listeners scoped by path. Each key should be the path to set up on-listeners for.
// Each value can have the following properties:
// maxListeners - indicates the maximum number of listeners to keep alive for the path
const onListeners = {
  photos: {
    maxListeners: 1
  }
};

/**
 * Manages the active database on-listeners for a given job and path
 * @param {string} jobKey - the job id to scope the path to
 * @param {string} path - the path to set up an on-listener for
 */
function manageListeners(jobKey, path) {
  // If we don't have a listener config for the path, quit
  if (!onListeners[path]) return;

  // Get the lookup of active listeners for the path, creating a lookup if there is none
  if (!onListeners[path].activeListeners) onListeners[path].activeListeners = {};
  const activeListenersForPath = onListeners[path].activeListeners;

  // If we already have a job listener set up, return
  if (activeListenersForPath[jobKey]) return;

  // Check if we have too many listeners for the path already
  const listenerCount = Object.keys(activeListenersForPath).length;
  if (listenerCount >= onListeners[path].maxListeners) {
    // Remove the oldest listener to make room for the new one
    const oldestListenerKey = Object.keys(activeListenersForPath).sort((a, b) => {
      return activeListenersForPath[a].created - activeListenersForPath[b].created;
    })[0];
    const oldestListener = activeListenersForPath[oldestListenerKey];
    oldestListener.pathRef.off('value', oldestListener.valueCallback);
    delete activeListenersForPath[oldestListenerKey];
  }

  // Create a listener for the path
  const pathRef = FirebaseWorker.ref(`photoheight/jobs/${jobKey}`).child(path);
  const valueCallback = pathRef.on('value', (s) => {});

  // Create a record for the listener
  activeListenersForPath[jobKey] = {
    valueCallback,
    pathRef,
    created: new Date().valueOf()
  };
}
